import { formatDateRequire } from "../../../components/commonClass/CommonValidation";
import { postUsersData } from "../../../services/ApiCallingUserServices";

type StateSetter<T> = React.Dispatch<React.SetStateAction<T>>;

export type BookingTableProps = {
    TravelCategoryId: number;
    activeTab: number;
    activeTabName?: string;
    BookingList: bookingDataResponse[];
    setBookingList?: StateSetter<any[]>;
    filteritems?: bookingDataResponse[];
    userRights?: any;
    searchvalue?: string;
    setSearchValue?: StateSetter<string>;
    searchby?: string;
    setSerachBy?: StateSetter<string>;
    serchdisable?: boolean;
    getbookingdatalist: () => Promise<void>;
}

export type BookingTabsProps = BookingTableProps & {
    activeTab: number;
    setActiveTab: StateSetter<number>;
}

export type HotelCancellationReasonProps = {
    show: boolean
    setShow: StateSetter<boolean>
    reason: string
}

export type bookingDataResponse =
    {
        BookingId: number
        BookingNo: string
        PaymentId: number
        Product: string
        BookingStatus: number
        PaymentStatus: number
        FirstName: string
        LastName: string
        MobileNo: string
        EmailId: string
        StartDate: string
        NoOfTraveller: number
        EndDate: string
        CreatedDate: string
        BookingCondition: number
        PNR: string | null
        TBOBookingId: number
        IsAutoCancel: boolean
        PartialCancelSegment: any
        CancellationReason: string
        Source: string
        SrNo: number
        PaymentStatusFormat: string | null
        CreatedDateFormat: string | null
        StartDateFormat: string | null
        EndDateFormat: string | null
        BookingStatusName: string | null
    }

//#region API calling functions
export const getmoallbookingbystatusid = async (TravelCategoryId: number, activeTab: number) => {
    const payloadData = {
        TravelCategoryId: TravelCategoryId,     // 1- Flight, 2 - Holiday, 5- Hotel
        BookingStatus: activeTab                // 2 - Upcoming, 3 - OnGoing, 5 - CancelBooking, 6 - Completed, 0 - Failed, 9 - Hold
    }
    try {
        const moallbookingbystatusid = await postUsersData('/midoffice/v1/getmoallbookingbystatusid', payloadData);
        if (moallbookingbystatusid?.status) {
            if (moallbookingbystatusid?.data) {
                return moallbookingbystatusid?.data?.map((obj: bookingDataResponse, index: number) => {
                    obj["SrNo"] = index + 1;
                    obj["PaymentStatusFormat"] = getPaymentStatusValue(obj?.PaymentStatus);
                    obj["CreatedDateFormat"] = formatDateRequire(obj?.CreatedDate);
                    obj["StartDateFormat"] = formatDateRequire(obj?.StartDate);
                    obj["EndDateFormat"] = formatDateRequire(obj?.EndDate);
                    obj["BookingStatusName"] = getBookingStatusValue(TravelCategoryId, obj?.BookingStatus, obj?.IsAutoCancel, activeTab, obj?.PartialCancelSegment?.length > 0);
                    return obj;
                })
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    } catch (error) {
        return [];
    }
}

//#endregion

//#region get id wise value or status
export const getTravellerCategory = (category?: number) => {
    switch (category) {
        case 1: return "flight";
        case 2: return "holiday";
        case 3: return "bus";
        case 4: return "train";
        case 5: return "hotel";
        default: return "";
    }
}

export const getPaymentStatusValue = (PaymentStatus: number) => {
    switch (PaymentStatus) {
        case 0: return "Failed";
        case 1: return "Successful";
        case 3: return "Pending Payment";
        default: return "Failed";
    }
}

export const getBookingStatusValue = (TravelCategoryId: number = 0, BookingStatus: number = 0, IsAutoCancel: boolean, activeTab: number, IsPartialCancel: boolean) => {
    // TravelCategoryId
    // 1 - flight
    // 2 - holiday
    // 3 - bus
    // 4 - train
    // 5 - hotel

    // BookingStatus
    // 0 - Init
    // 1 - Upcoming Progress
    // 2 - Upcoming Confirm
    // 3 - OnGoing
    // 4 - CancelBooking Pending
    // 5 - CancelBooking Completed
    // 6 - Completed
    // 7 - Booking Confirmation Pending
    // 8 - Partial Cancellation Pending
    // 9 - Hold
    // 10 - Partial Cancellation Confirm

    // IsAutoCancel: is hold booking auto cancelled or not, now only for Hotel.
    // IsPartialCancel :is for flight

    switch (TravelCategoryId) {
        case 1:
            switch (BookingStatus) {
                case 0: return "Failed"
                case 1: return "Confirmed"
                case 2: return "Confirmed"
                case 4: return "Cancelled"
                case 5: return "Cancelled"
                case 6: return IsPartialCancel ? "Partial Cancelled" : "Cancelled"
                case 7: return "Booking in progress"
                case 8: return activeTab === 5 ? "Pending" : "Confirmed"
                case 10: return activeTab === 5 ? "Partial Cancelled" : "Confirmed"
                default: return ""
            }
        case 2:
            switch (BookingStatus) {
                case 0: return "Failed"
                case 1: return "Pending"
                case 2: return "Confirmed"
                case 4: return "Pending"
                case 5: return "Cancellation Approved"
                case 7: return "Booking in progress"
                default: return ""
            }
        case 5:
            switch (BookingStatus) {
                case 0: return "Failed"
                case 1: return "Confirmed"
                case 2: return "Confirmed"
                case 4: return "Cancelled"
                case 5: return IsAutoCancel ? "Lapsed" : "Cancelled"
                case 7: return "Booking in progress"
                case 9: return "On Hold"
                default: return ""
            }
        default: return ""
    }
}

export const getBookingStatusBG = (status: number) => {
    switch (status) {
        case 0: return 'green-background'
        case 1: return 'yellow-background'
        default: return ''
    }
}

export const flightDateFormat = (date: any) => {
    const d = new Date(date);
    const weekday = d?.toLocaleString("en-US", { weekday: 'short' });
    const day = d?.toLocaleString("en-US", { day: 'numeric' });
    const month = d?.toLocaleString("en-US", { month: 'short' });
    const year = d?.toLocaleString("en-US", { year: 'numeric' });
    let hours = d?.getHours();
    const minute = d?.getMinutes()?.toString()?.padStart(2, '0')
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12; // the hour '0' should be '12'
    return date ? `${day}-${month}-${year} ${hours?.toString()?.padStart(2, '0')}:${minute} ${ampm}, ${weekday}` : null;
}

export const getCabinType = (type: number) => {
    switch (type) {
        case 1: return "All";
        case 2: return "Economy";
        case 3: return "PremiumEconomy";
        case 4: return "Business";
        case 5: return "PremiumBusiness";
        case 6: return "First";
        default: return '';
    }
}
export const getGenderTypeFlight = (type: number) => {
    switch (type) {
        case 1: return "Male";
        case 2: return "Female";
        default: return '';
    }
}

export const getGenderTypeHotel = (type: string) => {
    if (type === "") {
        return "N/A";
    }
    else if (type === "Mr") {
        return "Male";
    }
    else {
        return "Female";
    }
}

//#endregion